@if (!editEnabled) {
  <app-project-detail-mobile-list-item [title]="fileName" [expanded]="expanded" (toggle$)="onToggleExpand()">
    @if (!isReadOnlyUser) {
      <div mobileListActions>
        <button
          odxButton
          class="menu-button"
          [odxMenu]="imageCardMenu"
          odxMenuPosition="bottom-end"
          (click)="$event.stopPropagation()"
          [disabled]="!hasWritePermission"
          aria-label="Open image actions"
          i18n-aria-label="@@imageCard.button.openMenu"
        >
          <odx-icon name="more" size="large" aria-hidden="true"></odx-icon>
        </button>
      </div>
    }

    <div mobileListBody>
      <button type="button" class="preview-button" (click)="preview$.emit()">
        <div class="file-wrapper">
          @if (fileUrl) {
            <img [src]="fileUrl" [alt]="fileName" />
          }
        </div>
      </button>

      @if (isMonitoringScope && tags?.length) {
        <div class="tag-container">
          @for (tag of tags; track tag) {
            <odx-chip removable="false" size="small" variant="secondary" class="chip">
              {{ tag | translateProjectImageTag }}
            </odx-chip>
          }
        </div>
      }

      @if (isMonitoringScope && description) {
        <div class="description">
          <div class="odx-title-6" i18n="@@imageCard.description.label">Beschreibung</div>
          <p>{{ description }}</p>
        </div>
      }
    </div>
  </app-project-detail-mobile-list-item>
} @else {
  <odx-content-box class="file-content-box">
    <form odxForm [formGroup]="editForm">
      @if (isMonitoringScope) {
        <odx-form-field i18n-label="@@imageCard.editFormLocation.label" label="Ort" odxLayout="6">
          <input
            formControlName="name"
            odxFormFieldControl
            placeholder="Ort"
            i18n-placeholder="@@imageCard.editFormLocation.placeholder"
          />
        </odx-form-field>

        <odx-form-field i18n-label="@@imageCard.editFormTags.label" label="Tags" odxLayout="6">
          <odx-select multiple formControlName="tags" odxFormFieldControl>
            @for (item of tagList | odxAutocompleteSearchFilter; track item) {
              <odx-select-option [value]="item">
                {{ item | translateProjectImageTag }}
              </odx-select-option>
            }
            <input
              placeholder="Nach Tag suchen..."
              i18n-placeholder="@@imageCard.editFormTags.placeholder"
              odxSelectSearchField="Kein Tag gefunden"
              i18n-odxSelectSearchField="@@imageCard.editFormTags.noResult"
            />
          </odx-select>
        </odx-form-field>
      } @else {
        <odx-form-field i18n-label="@@imageCard.editFormName.label" label="Name" odxLayout="6">
          <input
            formControlName="name"
            odxFormFieldControl
            placeholder="Name"
            i18n-placeholder="@@imageCard.editFormName.placeholder"
          />
        </odx-form-field>
      }

      <div class="file-wrapper edit-file-wrapper">
        @if (fileUrl) {
          <img [src]="fileUrl" [alt]="fileName" />
        }
      </div>

      @if (isMonitoringScope) {
        <odx-form-field i18n-label="@@imageCard.editFormDescription.label" label="Beschreibung">
          <textarea formControlName="description" odxFormFieldControl></textarea>
        </odx-form-field>
      }

      <div class="button-container">
        <button
          odxButton
          variant="primary"
          type="submit"
          class="save-button"
          (click)="$event.stopPropagation(); onSubmit()"
          i18n="@@global.save"
        >
          Speichern
        </button>

        <button odxButton variant="secondary" (click)="onDelete()" i18n="@@global.delete">Löschen</button>

        <button odxButton variant="secondary" (click)="cancelEditMode()" i18n="@@global.dismiss">Abbrechen</button>
      </div>
    </form>
  </odx-content-box>
}

<ng-template #imageCardMenu>
  <odx-menu>
    <button odxButton odxMenuItem [disabled]="!hasWritePermission" (click)="$event.stopPropagation(); onOpenEdit()">
      <odx-icon name="edit" size="medium" alignleft></odx-icon>
      <span i18n="@@global.edit">Bearbeiten</span>
    </button>

    <button odxButton odxMenuItem [disabled]="!hasWritePermission" (click)="$event.stopPropagation(); onDelete()">
      <odx-icon name="delete" size="medium" alignleft></odx-icon>
      <span i18n="@@global.delete">Löschen</span>
    </button>
  </odx-menu>
</ng-template>
